var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6001",
    "data-name": "Group 6001",
    transform: "translate(-859 -675)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(859 675)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5997",
    "data-name": "Group 5997",
    transform: "translate(875 689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5998",
    "data-name": "Group 5998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    d: "M12.155,27.3A10.964,10.964,0,0,1,1.2,16.352C1.364,4.013,18.511,1.225,22.571,12.86a1.069,1.069,0,1,1-2.026.681,8.832,8.832,0,0,0-8.392-6c-11.678.443-11.676,17.188,0,17.63a8.9,8.9,0,0,0,1.528-.132,1.069,1.069,0,0,1,.368,2.1,11.1,11.1,0,0,1-1.9.164Z",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    d: "M11,3.152a1.069,1.069,0,0,1,2.137-.006,1.069,1.069,0,0,0,2.137,0,3.206,3.206,0,0,0-6.411.007,1.069,1.069,0,0,0,2.137,0Z",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7137",
    "data-name": "Path 7137",
    d: "M26.908,20.031a2.933,2.933,0,0,0-1.018-1.017h0l-4.771-2.831a2.965,2.965,0,0,0-4.473,2.52v5.662a2.966,2.966,0,0,0,4.474,2.52l4.771-2.831a2.934,2.934,0,0,0,1.018-4.023m-1.816,1.892a.792.792,0,0,1-.293.293v0l-4.771,2.831a.818.818,0,0,1-1.125-.269.827.827,0,0,1-.121-.413V18.7a.785.785,0,0,1,.406-.69.835.835,0,0,1,.84.007L24.8,20.851a.786.786,0,0,1,.293,1.072",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    d: "M13.813,16.4a1.6,1.6,0,1,1-2.671-1.195V10.636a1.069,1.069,0,1,1,2.137,0v4.575a1.6,1.6,0,0,1,.534,1.193",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    d: "M19.842,5.785a1.069,1.069,0,0,1,1.511-1.511l2.671,2.671a1.068,1.068,0,0,1-1.511,1.511Z",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7140",
    "data-name": "Path 7140",
    d: "M4.471,4.328a1.068,1.068,0,0,1,0,1.51h0L1.8,8.51A1.069,1.069,0,0,1,.289,7L2.96,4.328a1.069,1.069,0,0,1,1.511,0",
    fill: "#0a64f9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTime);
export default __webpack_public_path__ + "static/media/DeliveryTime.24637c4ed22ea7b97f6b4fdc7101a7bc.svg";
export { ForwardRef as ReactComponent };